export default "__VITE_ASSET__Lzl3pxGF__"